import { ClipLoader } from 'react-spinners';
import { differenceInMinutes } from 'date-fns';
import {
  ContactContainer,
  CouponContainer,
  LoadingPaymentMenthods,
  PaymentInBatchesContainer,
  PaymentInBatchesPage,
  PaymentMethodContainer,
} from './components/styled';
import { useCallback, useEffect, useRef, useState } from 'react';
import AsyncLoadingTable from './components/AsyncLoadingTable';
import PaymentMethods from './components/PaymentMethods';

import {
  FaCheckCircle,
  FaChevronDown,
  FaChevronUp,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
} from 'react-icons/fa';
import { RiErrorWarningFill, RiInstagramFill } from 'react-icons/ri';
import { IoLogoWhatsapp } from 'react-icons/io';
import { FaCircleChevronLeft, FaCircleChevronRight } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { StyledInput } from '../../components/StyledInput';
import { BsXCircleFill } from 'react-icons/bs';
import {
  IDebtsByUf,
  InstallmentInfo,
  useBatchPayment,
} from '../../context/BatchPaymentContext';
import debounce from 'lodash.debounce';
import GenericModal from '../../components/GenericModal';
import { FiChevronRight, FiX } from 'react-icons/fi';
import theme from '../../styles/themes/default';
import Swal from 'sweetalert2';
import { findConsultById } from '../../hooks/usePayments';
import Modal from 'react-modal';
import { Loading } from '../../components/Loading';
import { useUser } from '../../context/UserContext';
import { PiWarningCircleBold } from 'react-icons/pi';
import {
  IConsultsPackageStatusTypeEnum,
  useVehicle,
} from '../../context/VehiclesContext';
import { BatchProgressStatusBar } from '../../components/BatchProgressStatusBar';
import { addUserContactToConsultsBatch } from '../../hooks/useUsers';
import { useContactComunixFormData } from '../../context/ContactComunixContext';
import { handleMoneyValues } from '../../utils/formatCurrency';

export default function PaymentInBatches() {
  const {
    availableCoupon,
    cupomStatus,
    debtsForTable,
    installmentsLoading,
    allDebtsSelected,
    handleGetConsult,
    validateBatch,
    selectedDebts,
    installments,
    handleSetCupom,
    pix,
    isPix,
    debtsTotal,
    entryMessage,
    exitMessage,
    batchCode,
    // consultCode,
    // consultLoading,
    handleRefetchDebts,
    handleConsultClean,
  } = useBatchPayment();

  const {
    consultsCompletedStatus,
    batchDebtsConsultsProgress,
    consultsPackageStatus,
    consultsPackageModal,
    latestConsultsPackageStatus,
    packAndPostConsultsByDebts,
  } = useVehicle();

  const { isLoggedIn } = useUser();

  const hasRecreateBatchRun = useRef(false);

  const [order, setOrder] = useState<'desc' | 'asc'>('desc');
  const [orderBy, setOrderBy] = useState<string>('updated_at');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingPage, setIsLoadingPage] = useState<boolean>(false);
  const [isLoadingDebts, setIsLoadingDebts] = useState<boolean>(false);
  const [showCoupon, setShowCoupon] = useState<boolean>(true);
  const [cupom, setCupom] = useState<string | undefined>(undefined);
  const [zignetFee, seZignetFee] = useState<number>(0);
  const [entryMessageModal, setEntryMessageModal] = useState(false);
  const [exitMessageModal, setExitMessageModal] = useState(false);
  const [exitMessageComponent, setExitMessage] = useState('');
  const [showModalConfirmedPix, setShowModalConfirmedPix] = useState(false);

  const [installmentSelected, setInstallmentSelected] = useState<
    InstallmentInfo | undefined
  >(undefined);

  const navigate = useNavigate();

  const showErrorModal = async (error: string) => {
    Swal.fire({
      icon: 'error',
      title: 'Erro inesperado!',
      html: error,
      confirmButtonColor: theme.colors.orange.primary,
      didClose: () => {
        navigate('/debts');
      },
    });
  };

  const debouncedSave = useCallback(
    debounce((nextValue: any) => handleSetCupom(nextValue), 1000),
    [],
  );

  const handleCupomInput = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const regex = /[⁰¹²³⁴⁵⁶⁷⁸⁹ºª]/g;
      const value = e.currentTarget.value.replace(regex, '');

      setCupom(value);

      if (value.length === 0 || value.length > 4) {
        debouncedSave(value);
      }
    },
    [debouncedSave],
  );

  const handleClickEntryMessageModal = useCallback(() => {
    setEntryMessageModal(false);
    if (availableCoupon) {
      setCupom(availableCoupon);
      handleSetCupom(availableCoupon);
    }
  }, [availableCoupon]);

  const handleClickExitMessageModal = useCallback(() => {
    setExitMessageModal(false);
    setIsLoading(true);
    navigate('/debts/batch-payment/pix');
  }, []);

  const handlePayNowButton = useCallback(async () => {
    const showError = async (message: string) => {
      await showErrorModal(message);
    };
  
    if (!isLoggedIn) {
      Swal.fire({
        icon: 'warning',
        title: 'Aviso!',
        html: 'Tempo de operação expirado. Por favor, realize uma nova consulta para efetuar o pagamento.',
        confirmButtonColor: theme.colors.orange.primary,
      });
      return;
    }
  
    if (debtsTotal === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Aviso!',
        html: 'Nenhum débito selecionado',
        confirmButtonColor: theme.colors.orange.primary,
      });
      return;
    }
  
    if (!cupomStatus) {
      setCupom('');
      handleSetCupom('');
    }
  
    if (!batchCode) {
      await showError('Ocorreu um erro inesperado ao carregar os dados da consulta.');
      return;
    }
  
    if (!allDebtsSelected) {
      await showError('Ocorreu um erro inesperado ao carregar os dados da consulta.');
      return;
    }
  
    //TODO - Implement validation for debts already paid
    // const storageConsult = await findConsultById(consultCode ?? 0);
    // console.log('storageConsult', storageConsult);

    // if (storageConsult.payloadCaptura) {
    //   setIsLoadingPage(false);
    //   window.localStorage.setItem(
    //     'zignet:ConsultInProgress',
    //     JSON.stringify(storageConsult),
    //   );
    //   window.localStorage.setItem(
    //     'zignet:PayloadCaptura',
    //     JSON.stringify(storageConsult.payloadCaptura),
    //   );
    //   window.localStorage.setItem(
    //     'zignet:PayloadComprovante',
    //     JSON.stringify(storageConsult.payloadComprovante),
    //   );
    //   window.localStorage.setItem(
    //     'zignet:PayloadConsulta',
    //     JSON.stringify(storageConsult.payloadConsulta),
    //   );
    //   Swal.fire({
    //     icon: 'warning',
    //     html: `Já existe um pagamento em andamento para este veículo;`,
    //     confirmButtonColor: theme.colors.orange.primary,
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       navigate('/proof');
    //     }
    //   });
    //   return;
    // }

    // const checkConsultDuration =
    //   differenceInMinutes(new Date(), new Date(storageConsult?.created_at)) -
    //   180;
    // console.log(
    //   '🚀 ~ handlePayNowButton ~ checkConsultDuration:',
    //   checkConsultDuration,
    // );

    // if (checkConsultDuration >= 30) {
    // setIsLoadingPage(false);
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'Aviso!',
    //     html: 'Tempo de operação expirado. Por favor realize uma nova consulta para efetuar o pagamento',
    //     confirmButtonColor: theme.colors.orange.primary,
    //   });
    //   return;
    // }

    if (exitMessageComponent !== '') {
      setExitMessageModal(true);
      return;
    }
  
    setIsLoadingPage(true);
  
    try {
      if (pix?.checked) {
        navigate('/debts/batch-payment/pix');
      } else {
        navigate('/debts/batch-payment/credit-card');
      }
    } catch (error) {
      await showError('Ocorreu um erro ao redirecionar para o pagamento.');
    } finally {
      setIsLoadingPage(false);
    }
  }, [
    isLoggedIn,
    debtsTotal,
    cupomStatus,
    setCupom,
    handleSetCupom,
    batchCode,
    allDebtsSelected,
    exitMessageComponent,
    setExitMessageModal,
    setIsLoadingPage,
    pix,
    navigate,
    showErrorModal,
    theme.colors.orange.primary,
  ]);

  function sumAllDebtsByUf(debts: any[]) {
    const value = debts.reduce((acc, debt) => {
      return acc + debt.total;
    }, 0);

    return `R$ ${(value ?? 0)?.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  const disablePayButton =
    installments.length == 0 || !installments || installmentsLoading;

  useEffect(() => {
    const validateAndUpdateBatch = async () => {
      try {
        const isBatchValid = await validateBatch();
        console.log('Checking isBatchValid:', isBatchValid);

        const hasSelectedDebts = selectedDebts && selectedDebts.length > 0;
        if (!hasSelectedDebts) {
          await showErrorModal(
            `Ocorreu um erro na seleção de débitos. 
            Por favor, tente novamente mais tarde.`,
          );
          return;
        }

        if (!isBatchValid) {
          setIsLoadingDebts(true);
          await packAndPostConsultsByDebts(selectedDebts);
        } else if (debtsForTable.length > 0) {
          await handleGetConsult();
        }
      } catch (error) {
        console.error(
          'Erro durante a validação e atualização do batch:',
          error,
        );
        await showErrorModal(
          `Ocorreu um erro durante a validação do batch. 
          Por favor, tente novamente mais tarde.`,
        );
        return;
      }
    };
    if (!consultsPackageModal && !hasRecreateBatchRun.current) {
      validateAndUpdateBatch();
      hasRecreateBatchRun.current = true;
    }
  }, []);

  // Updates RecreatingBatch loading based on consult status
  useEffect(() => {
    const refetchDebts = async () => {
      if (
        consultsPackageModal?.type == IConsultsPackageStatusTypeEnum.FINISHED
      ) {
        await handleRefetchDebts(latestConsultsPackageStatus);
        setIsLoadingDebts(false);
      } else if (consultsPackageModal?.success === false) {
        // Falha ao criar/rodar o lote (ex.: id nulo, CNPJ inválido): encerra o
        // carregamento e mostra o motivo em vez de ficar em loop infinito.
        setIsLoadingDebts(false);
        if (consultsPackageModal.message) {
          await showErrorModal(String(consultsPackageModal.message));
        }
      }
    };
    refetchDebts();
  }, [consultsPackageModal]);

  useEffect(() => {
    setIsLoading(installmentsLoading);
  }, [installmentsLoading]);

  useEffect(() => {
    const refetechInstallments = async () => {
      console.log('debtsForTable updated:', debtsForTable);
      if(debtsForTable.length > 0 ){
        await handleGetConsult();
        
      } else {
        showErrorModal(
        `Ocorreu um erro na atualização de débitos. 
          Por favor, tente novamente mais tarde.`,
        );
      }
    }
    refetechInstallments();
  }, [debtsForTable, debtsTotal]);
  

  useEffect(() => {
    if (isPix) {
      setInstallmentSelected(pix);
    } else {
      const selected = installments.filter(
        (installment) => installment.checked,
      );
      setInstallmentSelected(
        selected && selected.length > 0 ? selected[0] : ({} as InstallmentInfo),
      );
    }
  }, [installments, pix]);

  useEffect(() => {
    if (!installmentsLoading) {
      const installmentsOnStorage = localStorage.getItem('@Zignet:parcelas');
      const pixOnStorage = localStorage.getItem('@Zignet:pix');

      if (
        !pix &&
        (!installments || installments?.length === 0) &&
        !pixOnStorage &&
        !installmentsOnStorage
      ) {
        showErrorModal(`Ocorreu um erro inesperado ao carregar os débitos.`);
      }
    }
  }, [installments, pix, installmentsLoading]);

  useEffect(() => {
    const installment = installments.find((i) => i.checked === true);
    if (installment) {
      const zignetFee = Number(installment?.totalPrice) - (debtsTotal ?? 0);
      seZignetFee(zignetFee);
    } else {
      const zignetFee = Number(pix?.totalPrice) - (debtsTotal ?? 0);
      seZignetFee(zignetFee);
    }
  }, [installments, debtsTotal, pix, zignetFee]);

  useEffect(() => {
    setEntryMessageModal(!!entryMessage);
  }, [entryMessage]);

  useEffect(() => {
    setExitMessage(exitMessage);
  }, [exitMessage]);

  return (
    <>
      {isLoadingPage && <Loading position="fixed" />}
      <PaymentInBatchesPage>
        <GenericModal open={exitMessageModal} setOpen={setExitMessageModal}>
          <span
            style={{
              display: 'flex',
              width: '100%',
              textAlign: 'center',
              fontSize: '32px',
              justifyContent: 'center',
              marginBottom: '10px',
              color: '#f58220',
            }}
          >
            <PiWarningCircleBold />
          </span>
          <div
            className={'entryMessageModal'}
            dangerouslySetInnerHTML={{
              __html: exitMessage,
            }}
          ></div>
          <div className="entryMessageModalButton">
            <button type="button" onClick={handleClickExitMessageModal}>
              {'Continuar'}
              <FiChevronRight />
            </button>
          </div>
        </GenericModal>
        {availableCoupon && (
          <GenericModal open={entryMessageModal} setOpen={setEntryMessageModal}>
            <span
              style={{
                display: 'flex',
                width: '100%',
                textAlign: 'center',
                fontSize: '32px',
                justifyContent: 'center',
                marginBottom: '10px',
                color: '#f58220',
              }}
            >
              {!availableCoupon && <PiWarningCircleBold />}
            </span>
            <div
              className={'entryMessageModal'}
              dangerouslySetInnerHTML={{
                __html: entryMessage,
              }}
            ></div>
            <div className="entryMessageModalButton">
              <button type="button" onClick={handleClickEntryMessageModal}>
                {availableCoupon ? 'Aplicar cupom' : 'Continuar'}
                <FiChevronRight />
              </button>
            </div>
          </GenericModal>
        )}

        <Modal
          isOpen={showModalConfirmedPix}
          onRequestClose={() => setShowModalConfirmedPix(false)}
          className={'modalConfirmedPix'}
          style={{
            overlay: { zIndex: 1001 },
            content: {},
          }}
        >
          <div className={'iconWarning'}>
            <RiErrorWarningFill size="44" />
          </div>
          <div
            className={'txtPoliticaPrivacidade'}
            id="warning-message"
            style={{
              textAlign: 'center',
            }}
          >
            Você está finalizando o pagamento de débitos da seguinte frota:
            {debtsForTable.map((debt) => {
              return (
                <p
                  style={{
                    textAlign: 'center',
                    marginTop: '5px',
                  }}
                >
                  {`${debt.uf} - `}
                  <span
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    {sumAllDebtsByUf(debt.data)}
                  </span>
                </p>
              );
            })}
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
              width: '100%',
            }}
          >
            <div className={'modalButton'}>
              <button
                onClick={() => {
                  setShowModalConfirmedPix(false);
                }}
              >
                Fechar
                <FiX />
              </button>
            </div>
            <div className={'modalButton'}>
              <button
                onClick={() => {
                  setShowModalConfirmedPix(false);
                  handlePayNowButton();
                }}
              >
                Pagar
                <FiChevronRight />
              </button>
            </div>
          </div>
        </Modal>

        <PaymentInBatchesContainer>
          <div className="container">
            <h1 className="page-title">Pagamento em lote</h1>

            <div className="loading-text">
              {isLoadingDebts && <ClipLoader size={25} color="#B4B4B4" />}
              <span>
                {isLoadingDebts
                  ? 'Carregando todos os débitos'
                  : 'Débitos carregados'}
              </span>

              {isLoadingDebts && consultsPackageStatus?.consultas?.length ? (
                <strong>
                  {`(${consultsCompletedStatus ?? 0} de ${
                    consultsPackageStatus?.consultas?.length ?? 0
                  } carregados)`}
                </strong>
              ) : (
                <strong>{`(${selectedDebts?.length || 0} débitos)`}</strong>
              )}
            </div>
            {consultsPackageModal?.type ==
              IConsultsPackageStatusTypeEnum.LOADING && (
              <BatchProgressStatusBar
                completedPercentage={batchDebtsConsultsProgress}
                barOnly={true}
              />
            )}

            <AsyncLoadingTable
              title="Listagem de Débitos"
              error={''}
              order={order}
              setOrder={setOrder}
              data={debtsForTable}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
              isLoading={true}
              isLoadingRecreatingBatch={isLoadingDebts}
            />
          </div>

          <div className="debts-table-list">
            <div className="contact-and-ticket">
              <ContactContainer>
                <h3>DÚVIDAS? FALE CONOSCO!</h3>

                <div className="content">
                  <div className="hour-address">
                    <div className="item">
                      <strong>Horário de Funcionamento</strong>
                      <span>Seg. a Sex. - 08hs às 19hs</span>
                    </div>
                    <div className="item">
                      <strong>Capital de SP e Regiões</strong>
                      <span>11 5171-8484</span>
                    </div>
                    <div className="item">
                      <strong>Demais Localidades</strong>
                      <span>0800 5800 094</span>
                    </div>
                  </div>
                  <div className="contacts">
                    <div className="item">
                      <strong>WhatsApp</strong>
                      <span>11 94549-1306</span>
                    </div>
                    <div className="item">
                      <strong>E-mail</strong>
                      <span>atendimento@zignet.com.br</span>
                    </div>
                    <div className="item icons">
                      <a
                        href="https://web.facebook.com/zignetbrasil"
                        target="_blank"
                      >
                        <FaFacebook />
                      </a>
                      <a
                        href="https://www.instagram.com/Zignet_oficial/"
                        target="_blank"
                      >
                        <RiInstagramFill />
                      </a>
                      <a
                        href="https://www.linkedin.com/company/zignet/"
                        target="_blank"
                      >
                        <FaLinkedin />
                      </a>
                      <a
                        href="https://api.whatsapp.com/send?phone=5511945491306&text=Ol%C3%A1,%20Zignet"
                        target="_blank"
                      >
                        <IoLogoWhatsapp />
                      </a>
                      <a
                        href="https://www.youtube.com/channel/UC07YZyHWRKS2xIbFptaT8Bg "
                        target="_blank"
                      >
                        <FaYoutube />
                      </a>
                    </div>
                  </div>
                </div>
              </ContactContainer>
              <CouponContainer valid={cupomStatus} open={showCoupon}>
                <div className="coupon-container">
                  <div className="header-togg">
                    <div
                      className="main-togg"
                      onClick={() => setShowCoupon(!showCoupon)}
                    >
                      <span> Inserir Cupom de Desconto </span>
                      {!showCoupon ? <FaChevronDown /> : <FaChevronUp />}
                    </div>
                    {availableCoupon && (
                      <div
                        className="available-status"
                        onClick={() => setEntryMessageModal(!entryMessageModal)}
                      >
                        <FaCheckCircle />
                        <span>Cupom disponível</span>
                      </div>
                    )}
                  </div>
                  <div
                    className={`content ${
                      cupomStatus === undefined ? 'neutral' : ''
                    }`}
                  >
                    {showCoupon && (
                      <div className="ticket-input">
                        <StyledInput
                          placeholder="Insira seu cupom de desconto"
                          value={cupom}
                          onChange={handleCupomInput}
                          icon={
                            cupom !== undefined && cupom.length > 0 ? (
                              cupomStatus ? (
                                <FaCheckCircle />
                              ) : (
                                <BsXCircleFill />
                              )
                            ) : undefined
                          }
                        />
                      </div>
                    )}
                    <div className="descount-values">
                      {!!installmentSelected?.discount &&
                        installmentSelected.discount > 0 && (
                          <div className="descount">
                            <span>Desconto aplicado</span>
                            <span>
                              {' '}
                              -
                              {handleMoneyValues(installmentSelected?.discount)}
                            </span>
                          </div>
                        )}
                      <div className="values">
                        <strong>Total Selecionado</strong>
                        <strong>
                          {isLoadingDebts || installmentsLoading
                            ? 'Carregando...'
                            : handleMoneyValues(zignetFee + debtsTotal)}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="actions">
                  <div
                    className="new-consult"
                    onClick={() => {
                      handleConsultClean();
                      navigate('/debts');
                    }}
                  >
                    <FaCircleChevronLeft />
                    <span>Nova Consulta</span>
                  </div>
                  <button
                    className={`submit-btn ${disablePayButton && 'disabled '}`}
                    disabled={disablePayButton}
                    onClick={() => {
                      if (!isLoading) {
                        if (pix?.checked) {
                          setShowModalConfirmedPix(true);
                        } else {
                          handlePayNowButton();
                        }
                      }
                    }}
                  >
                    <span>Pagar Agora</span>
                    <FaCircleChevronRight />
                  </button>
                </div>
              </CouponContainer>
            </div>
          </div>
        </PaymentInBatchesContainer>

        <PaymentMethodContainer>
          <h1 className="page-title method-title">Métodos de pagamento</h1>
          <div className="payment-methods">
            {installmentsLoading || isLoadingDebts ? (
              <LoadingPaymentMenthods>
                <div className="content">
                  <ClipLoader color={'#F58220'} size={45} />
                  <p>
                    Os métodos de pagamento aparecerão aqui após todos os
                    débitos serem carregados.
                  </p>
                </div>
              </LoadingPaymentMenthods>
            ) : installments && installments.length > 0 ? (
              <PaymentMethods />
            ) : (
              <LoadingPaymentMenthods>
                <div className="content">
                  <p>
                    Houve um erro. Não há débitos selecionados, por favor tente
                    novamente mais tarde.
                  </p>
                </div>
              </LoadingPaymentMenthods>
            )}
          </div>
        </PaymentMethodContainer>
      </PaymentInBatchesPage>
    </>
  );
}
